import axios from 'axios'
import Vue from 'vue'
import { buildVisiblePrice } from './Functions/buildVisiblePrice.js'
import { Loader } from '@googlemaps/js-api-loader'
import tippy, { followCursor } from 'tippy.js';
import MapNew from './Functions/initMap';

import docReady from './Functions/docReady';

docReady(function () {
    new MapNew();
});
